module.exports = __webpack_public_path__ + "cf3a7751e78fdf1ba142b63245f81c12.fbx";